import Container from "../Container";
import VideoThumb from "../VideoThumb";

export default function SectionConceptVideo(props) {

    return (
        <section className="bg-split-vertical">
            <Container fullMobile={true} className="h-72 md:h-gallery">
                <VideoThumb
                    className="w-full h-full"
                    showLabel={true}
                    fullMobile={true}
                    {...props}
                />
            </Container>
        </section>
    );
}
